export default __webpack_public_path__ + "static/media/flowers-no-1.b3989e78.ogg";